var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading"
        }
      ],
      staticClass: "double-authentication-page well b-1"
    },
    [
      _c(
        "h2",
        { staticClass: "m-0 mb-4 flex-row page-title" },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$l10n.__("Ma double authentification")))
          ]),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                placement: "bottom-end",
                disabled: !_vm.corporationEnabled,
                "popper-class": "twoFA"
              }
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__("La double authentification est obligatoire")
                    )
                ),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("et ne peut être désactivée.")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.isActivated
                    ? _c("CompassButton", {
                        staticClass: "btn-danger",
                        attrs: {
                          label: _vm.$t.__(
                            "pages.settings.doubleAuthentication.doubleAuthentication.disable"
                          ),
                          type: "primary-destructive",
                          disabled: _vm.isLoading || _vm.corporationEnabled
                        },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showConfirmation($event)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("p", { staticClass: "semibold fs-3 mt-0 mb-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "La double authentification permet de renforcer significativement la sécurité de votre compte Sellsy."
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3 mt-0 mb-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Si nous remarquons une tentative de connexion à partir d'un appareil non reconnu, nous vous demanderons un code de sécurité en plus de votre mot de passe. \nVous recevrez ce code via la méthode d'authentification configurée."
                )
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("DoubleAuthenticationStatus", { attrs: { active: _vm.isActivated } }),
      _vm._v(" "),
      !_vm.hasActiveProvider
        ? [
            _c("h3", { staticClass: "mt-0 mb-2" }, [
              _vm._v(
                _vm._s(_vm.$l10n.__("Méthode d'authentification principale"))
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 mt-0 mb-2" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Pour démarrer la configuration de la double authentification, sélectionnez une méthode d'authentification principale"
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "available-providers",
                attrs: { "data-test": "availableProviders" }
              },
              _vm._l(_vm.availableProviders, function(provider) {
                return _c("AvailableProvider2FA", {
                  key: provider.id,
                  attrs: { provider: provider }
                })
              }),
              1
            )
          ]
        : [
            _c("h3", { staticClass: "mt-0 mb-2" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Vos méthodes d'authentification")))
            ]),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "custom-table",
                attrs: { "data-test": "providersList" }
              },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.activatedProviders, function(provider) {
                    return _c("tr", { key: provider.id }, [
                      _c("td", { staticClass: "bold" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              provider.primary
                                ? _vm.$l10n.__(
                                    "Méthode d'authentification principale"
                                  )
                                : _vm.$l10n.__(
                                    "Méthode d'authentification secondaire "
                                  )
                            ) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "gray-60" }, [
                        _vm._v(_vm._s(provider.type))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "provider-type" }, [
                          _c(
                            "div",
                            { staticClass: "provider-type__icon" },
                            [_c("icon-" + provider.icon, { tag: "component" })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "provider-type__text m-0 bold" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(provider.label) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "pages.settings.doubleAuthentication.doubleAuthentication.disable"
                              ),
                              type: "secondary-destructive"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deactivateProvider(provider)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _vm.hasBackupCodes
              ? [
                  _c("h4", { staticClass: "mt-3 mb-2 fs-4" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Codes de secours")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-row" }, [
                    _c("div", { staticClass: "text-container" }, [
                      _c("p", { staticClass: "mt-0 mb-1 fs-3" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Si vous perdez votre appareil alors que la double authentification est activée, vous aurez besoin des codes de secours pour vous connecter à votre compte. Conservez-les en lieu sûr, de préférence avec vous."
                              )
                            ) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 gray-60 fs-3" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Chaque code de secours est à usage unique, mais n'hésitez pas à les utiliser car vous pouvez en générer des nouveaux."
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "code-actions" },
                      [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.$t.__(
                              "pages.settings.doubleAuthentication.doubleAuthentication.view_codes"
                            ),
                            type: "secondary",
                            "data-test": "btnBackupCodes"
                          },
                          on: { click: _vm.showBackupCodes }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 gray-60 semibold aright",
                            attrs: { "data-test": "unusedBackupCodes" }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.unusedBackupCodes) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.secondaryProvidersAvailable
              ? [
                  _c("h3", { staticClass: "mt-6 mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$l10n.__("Méthodes d'authentification secondaire")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-container" }, [
                    _c("p", { staticClass: "fs-3 mt-0 mb-2" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Configurer une méthode secondaire vous permet de vous connecter à votre compte même si vous n'avez pas accès à votre méthode principale sur le moment."
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "available-providers" },
                    _vm._l(_vm.secondaryProviders, function(provider) {
                      return _c("AvailableProvider2FA", {
                        key: provider.id,
                        attrs: { provider: provider }
                      })
                    }),
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.hasTrustedDevices
              ? [
                  _c("h3", { staticClass: "mt-6 mb-2" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Appareils de confiance")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-container" }, [
                    _c("p", { staticClass: "fs-3 mt-0 mb-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Aucun code de sécurité ne vous sera demandé pendant 30 jours lorsque vous vous connectez à partir d'un appareil de confiance."
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "gray-60 fs-3 mt-0 mb-3" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Si vous ne reconnaissez pas un appareil de confiance ou s'il n'est plus en votre possession, supprimez-le immédiatement."
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    {
                      staticClass: "custom-table",
                      attrs: { "data-test": "trustedDevices" }
                    },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.trustedDevices, function(trustedDevice) {
                          return _c("tr", { key: trustedDevice.id }, [
                            _c("td", { staticClass: "bold" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.formatDeviceType(trustedDevice.device)
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(trustedDevice.os) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(trustedDevice.browser) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__("Première connexion :")
                                    ) +
                                    "\n                                " +
                                    _vm._s(
                                      _vm.formatCreationDate(
                                        trustedDevice.created_at
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "gray-60 fs-2" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__("Dernière activité :")
                                    ) +
                                    "\n                                " +
                                    _vm._s(
                                      _vm.formatLastLoginDate(
                                        trustedDevice.last_login_at
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "pages.settings.doubleAuthentication.doubleAuthentication.no_longer_trust"
                                    ),
                                    type: "secondary-destructive"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.removeTrustedDevice(
                                        trustedDevice
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }